import { Box, Button, Checkbox, Divider, FormControl, FormControlLabel, FormGroup, FormHelperText, FormLabel, Grid, IconButton, InputLabel, MenuItem, Radio, RadioGroup, Select, Typography, useMediaQuery } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form';
// import AccountList from './AccountList';
import { accountTypeDataArray, checkboxColorSx, currencyArray, radioColorSx, radioOptionArray, useOfAccountArray } from 'store/constant';
// import { yupResolver } from '@hookform/resolvers/yup';
// import * as Yup from 'yup';
import axiosInstance from 'custom-axios';
import { ToastContainer, toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faFileAlt, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { useFullPageLoader } from 'hooks/useFullPageLoader';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { showConfirmSweetAlert } from 'hooks/useSweetAlert';
import Swal from 'sweetalert2';

const AccountTypeInformation = ({ accountTypeRef, accountTypeId, setActiveChildStep, formAccountData, setFormAccountData, userId, activeAccountStep, setActiveAccountStep, setActiveParentStep }) => {

    const [loader, showLoader, hideLoader] = useFullPageLoader();
    // const matchesMD = useMediaQuery((theme) => theme.breakpoints.down('md'));
    // let loginId = localStorage.getItem('login_id');
    const [userData, setUserData] = useState({
        p_marital_status: '',
        spousal_first_name: '',
        spousal_last_name: ''
    })

    const [files, setFiles] = useState([]);
    // const [custodyNameData, setCustodyName] = useState([])
    var [personRegisterAccountDetails, setPersonRegisterAccountDetails] = useState([]);
    var [personNonRegisterAccountDetails, setPersonNonRegisterAccountDetails] = useState([]);

    var [spousalRegisterAccountDetails, setSpousalRegisterAccountDetails] = useState([]);
    var [spousalNonRegisterAccountDetails, setSpousalNonRegisterAccountDetails] = useState([]);

    // const validationSchema = Yup.object().shape({
    //     p_account_holder: Yup.string().required(),
    //     account_type: Yup.string().required()
    // });

    const {
        register,
        handleSubmit,
        setValue,
        trigger,
        control,
        formState: { errors }
    } = useFormContext();

    // Push local arrays to RHF Context silently for jump submissions
    useEffect(() => {
        setValue('person_register_accounts', personRegisterAccountDetails, { shouldDirty: true });
        setValue('person_non_register_accounts', personNonRegisterAccountDetails, { shouldDirty: true });
        setValue('spousal_register_accounts', spousalRegisterAccountDetails, { shouldDirty: true });
        setValue('spousal_non_register_accounts', spousalNonRegisterAccountDetails, { shouldDirty: true });
    }, [personRegisterAccountDetails, personNonRegisterAccountDetails, spousalRegisterAccountDetails, spousalNonRegisterAccountDetails, setValue]);


    React.useImperativeHandle(accountTypeRef, () => ({
        triggerValidation: async () => {
            const isValid = await trigger();
            return isValid;
        }
    }));

    const fetchUserData = async () => {

        showLoader();
        try {
            const response = await axiosInstance.get(`api/get-user-personal-info/${userId}`);

            if (response.data) {

                setUserData({
                    ...userData,
                    p_marital_status: response.data.p_marital_status,
                    spousal_first_name: response.data.s_first_name,
                    spousal_last_name: response.data.s_last_name,
                    s_investing_account: response.data.s_investing_account,
                });

            }
        } catch (error) {
            // console.error(error.message);
        }
    }

    const fetchAccountTypeData = async () => {
        try {
            const response = await axiosInstance.get(`api/get-user-account-type-info/${userId}`);

            if (response.data) {


                setPersonRegisterAccountDetails(response.data.person_register_accounts)
                setPersonNonRegisterAccountDetails(response.data.person_non_register_accounts)
                setSpousalRegisterAccountDetails(response.data.spousal_register_accounts)
                setSpousalNonRegisterAccountDetails(response.data.spousal_non_register_accounts)
                setFiles(response.data.account_statement_files)
                setFormAccountData(prevFormData => ({
                    ...prevFormData,
                    // ...response.data,
                    person_register_accounts: response.data.person_register_accounts,
                    person_non_register_accounts: response.data.person_non_register_accounts,
                    spousal_register_accounts: response.data.spousal_register_accounts,
                    spousal_non_register_accounts: response.data.spousal_non_register_accounts,
                    is_spousal_account: response.data.is_spousal_account
                }));
            }
            // setLoadData(true)
        } catch (error) {
            // console.error(error.message);
        }
    }

    const handleCheckRegisterAccount = (event, index) => {

        setPersonRegisterAccountDetails((prev) =>
            prev.map((account, i) =>
                i == index
                    ? {
                        ...account,
                        account_checked: Boolean(event.target.checked),
                        account_type_currency: event.target.checked ? 1 : 0, // Set to 1 when checked, 0 otherwise
                    }
                    : account
            )
        );
    };

    const handleCheckNonRegisterAccount = (event, index) => {
        setPersonNonRegisterAccountDetails((prev) => {
            const updated = [...prev];
            updated[index].account_checked = event.target.checked;
            updated[index].account_type_currency = event.target.checked == true ? 1 : 0;
            return updated;
        });
    };

    const changeRegAccountCurrency = (event, index) => {
        setPersonRegisterAccountDetails((prev) => {
            const updated = [...prev];
            updated[index].account_type_currency = event.target.value == 1 ? 1 : 2;
            return updated;
        });
    };

    const changeNonRegAccountCurrency = (event, index) => {
        setPersonNonRegisterAccountDetails((prev) => {
            const updated = [...prev];
            updated[index].account_type_currency = event.target.value == 1 ? 1 : 2;
            return updated;
        });
    };

    // ----------------------spousal handle change method ---------------//
    // non-reg account data method
    const handleCheckSpousalNonRegisterAccount = (event, index) => {
        setSpousalNonRegisterAccountDetails((prev) => {
            const updated = [...prev];
            updated[index].account_checked = event.target.checked;
            updated[index].account_type_currency = event.target.checked == true ? 1 : 0;
            return updated;
        });
    };

    const changeSpousalNonRegAccountCurrency = (event, index) => {
        setSpousalNonRegisterAccountDetails((prev) => {
            const updated = [...prev];
            updated[index].account_type_currency = event.target.value == 1 ? 1 : 2;
            return updated;
        });
    };

    const handleSpousalIntendedUseChange = (event, index, useId) => {
        setSpousalNonRegisterAccountDetails((prev) => {

            const updated = prev.map((account, i) => {

                if (i === index) {

                    const updatedUses = event.target.checked
                        ? [...(account.intended_use_of_account || []), useId]
                        : (account.intended_use_of_account || []).filter((id) => id !== useId);

                    return {
                        ...account,
                        intended_use_of_account: updatedUses,
                    };
                }
                return account;
            });
            return updated;
        });
    };

    const handleChangeSpousalNonRegAccountData = (e, index) => {
        const { name, value } = e.target
        const updatedData = [...spousalNonRegisterAccountDetails];
        updatedData[index][name] = value;
        setSpousalNonRegisterAccountDetails(updatedData);
    }


    // reg account data method
    const handleCheckSpousalRegisterAccount = (event, index) => {
        setSpousalRegisterAccountDetails((prev) => {
            const updated = [...prev];
            updated[index].account_checked = event.target.checked;
            updated[index].account_type_currency = event.target.checked == true ? 1 : 0;
            return updated;
        });
    };

    const changeSpousalRegAccountCurrency = (event, index) => {
        setSpousalRegisterAccountDetails((prev) => {
            const updated = [...prev];
            updated[index].account_type_currency = event.target.value == 1 ? 1 : 2;
            return updated;
        });
    };

    const handleSpousalRegIntendedUseChange = (event, index, useId) => {
        setSpousalRegisterAccountDetails((prev) => {

            const updated = prev.map((account, i) => {

                if (i === index) {

                    const updatedUses = event.target.checked
                        ? [...(account.intended_use_of_account || []), useId]
                        : (account.intended_use_of_account || []).filter((id) => id !== useId);

                    return {
                        ...account,
                        intended_use_of_account: updatedUses,
                    };
                }
                return account;
            });
            return updated;
        });
    };

    const handleChangeSpousalRegAccountData = (e, index) => {
        const { name, value } = e.target
        const updatedData = [...spousalRegisterAccountDetails];
        updatedData[index][name] = value;
        setSpousalRegisterAccountDetails(updatedData);
    }

    // --------------------------- end of spousal onChange method -----------------------------------//

    const handlePerNonIntendedUseChange = (event, index, useId) => {
        setPersonNonRegisterAccountDetails((prev) => {

            const updated = prev.map((account, i) => {

                if (i === index) {

                    const updatedUses = event.target.checked
                        ? [...(account.intended_use_of_account || []), useId]
                        : (account.intended_use_of_account || []).filter((id) => id !== useId);

                    return {
                        ...account,
                        intended_use_of_account: updatedUses,
                    };
                }
                return account;
            });
            return updated;
        });
    };

    const handlePerRegIntendedUseChange = (event, index, useId) => {
        setPersonRegisterAccountDetails((prev) => {

            const updated = prev.map((account, i) => {

                if (i === index) {

                    const updatedUses = event.target.checked
                        ? [...(account.intended_use_of_account || []), useId]
                        : (account.intended_use_of_account || []).filter((id) => id !== useId);

                    return {
                        ...account,
                        intended_use_of_account: updatedUses,
                    };
                }
                return account;
            });
            return updated;
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target
        setFormAccountData({ ...formAccountData, [name]: value })
    }

    const handleChangeRegAccountData = (e, index) => {
        const { name, value } = e.target;
        const updatedData = [...personRegisterAccountDetails];
        updatedData[index][name] = value;
        setPersonRegisterAccountDetails(updatedData);
    };

    const handleChangeNonRegAccountData = (e, index) => {
        const { name, value } = e.target
        const updatedData = [...personNonRegisterAccountDetails];
        updatedData[index][name] = value;
        setPersonNonRegisterAccountDetails(updatedData);
    }

    const addPersonNonRegisterAccountType = (label, value) => {

        let lastIndex = personNonRegisterAccountDetails
            .map((acc, idx) => (acc.value === value ? idx : -1))
            .filter(idx => idx !== -1)
            .pop(); // Get the last index of the same account type

        if (lastIndex !== undefined) {
            const updatedAccounts = [...personNonRegisterAccountDetails];
            updatedAccounts.splice(lastIndex + 1, 0, {
                label,
                value,
                account_checked: false,
                account_type_currency: 1,
                account_count: updatedAccounts.filter(acc => acc.value === value).length + 1,
                intended_use_of_account: [],
                account_eft: 1,
                account_transfer: 2,
                account_pac: 2,
                account_swp: 2,
                account_income_sweep: 2
            });
            setPersonNonRegisterAccountDetails(updatedAccounts);
        }
    };

    const addSpousalNonRegAccountType = (label, value) => {

        let lastIndex = spousalNonRegisterAccountDetails
            .map((acc, idx) => (acc.value === value ? idx : -1))
            .filter(idx => idx !== -1)
            .pop(); // Get the last index of the same account type


        if (lastIndex !== undefined) {
            const updatedAccounts = [...spousalNonRegisterAccountDetails];
            updatedAccounts.splice(lastIndex + 1, 0, {
                label,
                value,
                account_checked: false,
                account_type_currency: 1,
                account_count: updatedAccounts.filter(acc => acc.value === value).length + 1,
                intended_use_of_account: [],
                account_eft: 1,
                account_transfer: 2,
                account_pac: 2,
                account_swp: 2,
                account_income_sweep: 2
            });
            setSpousalNonRegisterAccountDetails(updatedAccounts);
        }
    };


    // add new person register account
    const addNewPersonRegAccount = (label, value) => {

        let lastIndex = personRegisterAccountDetails
            .map((acc, idx) => (acc.value === value ? idx : -1))
            .filter(idx => idx !== -1)
            .pop(); // Get the last index of the same account type

        if (lastIndex !== undefined) {
            const updatedAccounts = [...personRegisterAccountDetails];
            updatedAccounts.splice(lastIndex + 1, 0, {
                label,
                value,
                account_checked: false,
                account_type_currency: 1,
                account_count: updatedAccounts.filter(acc => acc.value === value).length + 1,
                intended_use_of_account: [],
                account_eft: 1,
                account_transfer: 2,
                account_pac: 2,
                account_swp: 2,
                account_income_sweep: 2
            });
            setPersonRegisterAccountDetails(updatedAccounts);
        }
    };

    const addNewSpousalRegAccount = (label, value) => {

        let lastIndex = spousalRegisterAccountDetails
            .map((acc, idx) => (acc.value === value ? idx : -1))
            .filter(idx => idx !== -1)
            .pop(); // Get the last index of the same account type

        if (lastIndex !== undefined) {
            const updatedAccounts = [...spousalRegisterAccountDetails];
            updatedAccounts.splice(lastIndex + 1, 0, {
                label,
                value,
                account_checked: false,
                account_type_currency: 1,
                account_count: updatedAccounts.filter(acc => acc.value === value).length + 1,
                intended_use_of_account: [],
                account_eft: 1,
                account_transfer: 2,
                account_pac: 2,
                account_swp: 2,
                account_income_sweep: 2
            });
            setSpousalRegisterAccountDetails(updatedAccounts);
        }
    };

    const removePersonNonRegisterAccountType = (index, isAccountUsed, isAccountUsedMessage) => {

        if (isAccountUsed) {
            Swal.fire({
                icon: "error",
                text: isAccountUsedMessage,
            });
            return;
        }

        const updatedData = personNonRegisterAccountDetails.filter((_, i) => i !== index);
        setPersonNonRegisterAccountDetails(updatedData);
    };

    const removeSpousalNonRegisterAccountType = (index, isAccountUsed, isAccountUsedMessage) => {

        if (isAccountUsed) {
            Swal.fire({
                icon: "error",
                text: isAccountUsedMessage,
            });
            return;
        }

        const updatedData = spousalNonRegisterAccountDetails.filter((_, i) => i !== index);
        setSpousalNonRegisterAccountDetails(updatedData);
    };

    const removePersonRegisterAccountType = (index, isAccountUsed, isAccountUsedMessage) => {

        if (isAccountUsed) {
            Swal.fire({
                icon: "error",
                text: isAccountUsedMessage,
            });
            return;
        }

        const updatedData = personRegisterAccountDetails.filter((_, i) => i !== index);
        setPersonRegisterAccountDetails(updatedData);
    };

    const removeSpousalRegisterAccountType = (index, isAccountUsed, isAccountUsedMessage) => {

        if (isAccountUsed) {
            Swal.fire({
                icon: "error",
                text: isAccountUsedMessage,
            });
            return;
        }

        const updatedData = spousalRegisterAccountDetails.filter((_, i) => i !== index);
        setSpousalRegisterAccountDetails(updatedData);
    };


    const handleRoleBack = async () => {
        showLoader();
        // setActiveAccountStep(activeAccountStep - 1);
        let endPoint = `api/change-form-step`;

        const submitData = { user_id: userId ? userId : 0, parent_step: 0, child_step: 4 } // go back to household last step

        try {
            const response = await axiosInstance.post(endPoint, submitData);

            if (response.status === 200) {
                setActiveAccountStep(0);
                setActiveParentStep(0)
                setActiveChildStep(4)
            }

        } catch (error) {
            // console.error(error)
            toast.error('An error occurred when navigating back.')
        } finally {
            hideLoader();
        }

    };

    const uploadHandler = async (e) => {

        const file = e.target.files[0];
        const maxSize = 2 * 1024 * 1024; // 2 MB in bytes

        const allowedTypes = [
            'application/pdf',
            // 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            // 'application/msword',
            'image/jpeg',
            'image/png'
        ];

        if (!allowedTypes.includes(file.type)) {
            toast.error('Unsupported file type. Only PDF, JPEG, and PNG are allowed.');
            return;
        }

        if (file.size > maxSize) {
            toast.error('File size is too large. Maximum 2 MB allowed.');
            return;
        }

        const formData = new FormData()

        formData.append('file', file)
        formData.append('user_id', userId)
        let fileSize = (formData.get('file').size)
        formData.append('file_size', fileSize)

        showLoader()
        const response = axiosInstance.post(`api/upload-account-statement-file`, formData);

        response.then(function (result) {

            if (result.success) {
                fetchData()

                toast.success(result.message)
            } else {
                toast.error(result.message)
            }
        }).catch((err) => {
            // console.error(err)
        });

        hideLoader()
    }

    const deleteFileHandler = async (_name, id) => {

        try {
            const result = await showConfirmSweetAlert({
                title: 'Are you sure?',
                text: `You will not be able to recover this!`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, cancel!',
            });

            if (result.isConfirmed) {

                showLoader()

                const response = await axiosInstance.delete(`api/delete-account-statement-file/${id}/${userId}`);

                if (response.success) {

                    setFiles((prevFiles) =>
                        prevFiles.filter((file) => file.id !== id)
                    );

                    toast.success(response.message);
                } else {
                    toast.error(response.message);
                }
            }

        } catch (error) {
            // toast.error(error.message)
            // console.log(error)
        } finally {
            hideLoader();
        }
    }

    const downloadFile = async (_name, id) => {
        showLoader();
        try {
            const response = await axiosInstance.get(`api/download-account-statement-file/${id}/${userId}`, {
                responseType: 'blob',
                validateStatus: (status) => {
                    return status >= 200 && status < 500;
                },
            });

            // const contentType = response.headers['content-type'];
            const contentType = response.type;


            if (contentType === 'application/json') {

                const reader = new FileReader();
                reader.onload = () => {
                    const errorResponse = JSON.parse(reader.result);
                    toast.error(errorResponse.error || 'File not found.');
                };
                reader.readAsText(response.data);
            } else {

                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', _name);
                document.body.appendChild(link);
                link.click();
                link.remove();
            }

        } catch (error) {
            toast.error('An error occurred while downloading the file.');
            // console.error('Error downloading the file', error);

        } finally {
            hideLoader();
        }
    }

    // const useOfAccountError = formAccountData.intended_use_of_account.filter((v) => v).length == 0;

    const submitRoleForm = async () => {

        // if (!useOfAccountError) {
        showLoader();
        let endPoint = `api/save-user-account-type-info`;

        const submitData = {
            // ...formAccountData,
            person_register_accounts: personRegisterAccountDetails,
            person_non_register_accounts: personNonRegisterAccountDetails,
            spousal_register_accounts: spousalRegisterAccountDetails,
            spousal_non_register_accounts: spousalNonRegisterAccountDetails,
            login_id: formAccountData.login_id,
            is_spousal_account: formAccountData.is_spousal_account,
            account_type_id: accountTypeId,
            user_id: userId ? userId : 0,
            parent_step: 1,
            child_step: activeAccountStep + 1
        }


        setFormAccountData(prevFormData => ({
            ...prevFormData,
            person_register_accounts: personRegisterAccountDetails,
            person_non_register_accounts: personNonRegisterAccountDetails,
            spousal_register_accounts: spousalRegisterAccountDetails,
            spousal_non_register_accounts: spousalNonRegisterAccountDetails,
        }));

        try {

            const response = await axiosInstance.post(endPoint, submitData);

            if (response.status === 200) {
                setActiveAccountStep(activeAccountStep + 1)
            }

        } catch (error) {
            // console.error(error)
            toast.error('An error occurred while saving information.')
        } finally {
            hideLoader();
        }
    }

    async function fetchData() {
        showLoader();
        await fetchAccountTypeData();
        await fetchUserData();
        hideLoader();
    }

    useEffect(() => {
        fetchData();
    }, [])

    return (
        <>
            <form onSubmit={handleSubmit(submitRoleForm)}>
                <Grid container spacing={2} className='p-4'>

                    <Grid item xs={12} sm={12} md={12} className='d-flex'>
                        <Grid item xs={5} sm={5} md={5}>
                            <label className='font15px margin-top10px font-weight500px'>Non-Registered Account</label>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                        <FormControl>
                            <Controller
                                name="item_ids_non_reg"
                                {...register('pNonRegisterSubAccountType')}
                                render={(props) =>
                                    personNonRegisterAccountDetails?.map((item, index) => {

                                        return (
                                            <>
                                                {/* {(index > 0) && <Divider className="divider" sx={{ marginTop: '0px' }} />} */}

                                                <div className="d-flex">
                                                    <input
                                                        class="custom-checkbox"
                                                        id={`account_non_reg_type${index}`}
                                                        type="checkbox"
                                                        onChange={(e) => handleCheckNonRegisterAccount(e, index)}
                                                        checked={item.account_checked}
                                                    />
                                                    <label
                                                        htmlFor={`account_non_reg_type${index}`}
                                                        className="label-account-type"
                                                    >
                                                        {item.label}
                                                    </label>

                                                    {/* --------option ----------- */}
                                                    <div className="form-check form-check-inline">
                                                        <FormControlLabel
                                                            control={<Radio sx={{ radioColorSx }} />}
                                                            label="CDN"
                                                            checked={item.account_type_currency == 1}
                                                            onChange={(e) => changeNonRegAccountCurrency(e, index)}
                                                            name={`account_non_reg_currency${item.value}`}
                                                            id={`s_{item.value}`}
                                                            value={1}
                                                            disabled={item.account_checked == true ? false : true}
                                                        />
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <FormControlLabel
                                                            control={<Radio sx={{ radioColorSx }} />}
                                                            label="USD"
                                                            checked={item.account_type_currency == 2}
                                                            onChange={(e) => changeNonRegAccountCurrency(e, index)}
                                                            id={`account_non_reg_usd${item.value}`}
                                                            name={`account_non_reg_currency${item.value}`}
                                                            value={2}
                                                            disabled={item.account_checked == true ? false : true}
                                                        />
                                                    </div>

                                                    {
                                                        (item?.account_count > 1) &&
                                                        <IconButton disabled={index === 0} onClick={() => removePersonNonRegisterAccountType(index, item.is_account_used, item?.is_account_used_message)} color="error">
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    }
                                                </div>

                                                {(item.account_count > 1) && <Divider className="divider mt-0" />}

                                                {item.account_checked && (
                                                    <>
                                                        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                                                            <Grid item xs={6}>
                                                                <Grid item xs={12} sm={12} md={12}>
                                                                    <label className='font15px margin-top10px'>What are the intended use of the accounts?</label>
                                                                </Grid>

                                                                <Grid item xs={12} sm={12} md={12} className='ml-10px mt-2'>
                                                                    <FormControl
                                                                        component="fieldset"
                                                                        variant="standard"
                                                                    >
                                                                        <FormGroup>
                                                                            {useOfAccountArray.map((option) => (
                                                                                <FormControlLabel
                                                                                    key={option.value}
                                                                                    className="custom-form-control-label"
                                                                                    control={
                                                                                        <Checkbox
                                                                                            sx={{
                                                                                                ...checkboxColorSx,
                                                                                                fontSize: "12px",
                                                                                                width: "max-content"
                                                                                            }}
                                                                                            checked={item.intended_use_of_account.includes(option.value)}
                                                                                            onChange={(e) => handlePerNonIntendedUseChange(e, index, option.value)}
                                                                                        />
                                                                                    }
                                                                                    // label={option.label}
                                                                                    label={<Typography sx={{ fontSize: '14px', color: '#444' }}>{option.label}</Typography>}
                                                                                />
                                                                            ))}
                                                                        </FormGroup>
                                                                    </FormControl>
                                                                </Grid>
                                                            </Grid>

                                                            <Grid item xs={6} className='mt-4'>
                                                                {accountTypeDataArray.map(({ label, name, defaultValue, disabled }) => (
                                                                    <Grid container key={name} className="d-flex align-items-center mt-2" spacing={2}>
                                                                        <Grid item xs={12} sm={6} md={6} className='align-content-center pt-0'>
                                                                            <label htmlFor={`p-non-reg-${name}`} className="font14px">{label}</label>
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={6} md={6} className='align-content-center pt-0'>
                                                                            <FormControl component="fieldset">
                                                                                <RadioGroup
                                                                                    row
                                                                                    id={`p-non-reg-${name}`}
                                                                                    aria-labelledby={name}
                                                                                    name={name}
                                                                                    value={disabled ? 2 : item[name] ?? defaultValue ?? ''}
                                                                                    disabled={disabled}
                                                                                    onChange={(e) => handleChangeNonRegAccountData(e, index)}
                                                                                >
                                                                                    {radioOptionArray.map((option) => (
                                                                                        <FormControlLabel
                                                                                            key={option.value}
                                                                                            value={option.value}
                                                                                            control={<Radio
                                                                                                sx={{
                                                                                                    ...radioColorSx,
                                                                                                    fontSize: "12px"
                                                                                                }} />
                                                                                            }
                                                                                            label={option.label}
                                                                                        />
                                                                                    ))}
                                                                                </RadioGroup>
                                                                            </FormControl>
                                                                        </Grid>

                                                                        {name === 'account_eft' && (
                                                                            <Grid item xs={12} className="align-self-center text-center font12px pt-0" sx={{ color: '#e05e5ecf' }}>
                                                                                Any account with a PAC, SWP, or Income Sweep that includes a bank account will also require EFT
                                                                            </Grid>
                                                                        )}
                                                                    </Grid>
                                                                ))}
                                                            </Grid>

                                                            {index === personNonRegisterAccountDetails.findIndex(acc => acc.value === item.value) && (
                                                                <Grid item xs={12} sm={12} md={12} className='d-flex'>
                                                                    <Button
                                                                        sx={{ ml: "10px" }}
                                                                        onClick={() => addPersonNonRegisterAccountType(item.label, item.value)}
                                                                        startIcon={<AddIcon />}
                                                                    >
                                                                        Add New {item.label}
                                                                    </Button>

                                                                </Grid>
                                                            )}
                                                        </Grid>
                                                    </>
                                                )}
                                            </>
                                        )
                                    })
                                }
                                control={control}
                            />
                        </FormControl>

                        <Divider className="divider mt-0" />

                    </Grid>

                    {/* ---------------------------- Registered Account ---------------------------- */}
                    <Grid item xs={12} sm={12} md={12} className='d-flex'>
                        <Grid item xs={5} sm={5} md={5}>
                            <label className='font15px margin-top10px font-weight500px'>Registered Account</label>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                        <FormControl>
                            <Controller
                                name="item_ids"
                                {...register('pRegisterSubAccountType')}
                                render={(props) =>
                                    personRegisterAccountDetails?.map((item, regIndex) => {
                                        return (
                                            <>


                                                <div className="d-flex">
                                                    <input
                                                        class="custom-checkbox"
                                                        id={`p_account_type${regIndex}`}
                                                        type="checkbox"
                                                        onChange={(e) => handleCheckRegisterAccount(e, regIndex)}
                                                        checked={item.account_checked}
                                                    />
                                                    <label
                                                        htmlFor={`p_account_type${regIndex}`}
                                                        className='account-type-label'
                                                    >
                                                        {item.label}
                                                    </label>

                                                    <div
                                                        className="form-check form-check-inline"
                                                    >
                                                        <FormControlLabel
                                                            control={<Radio sx={{ radioColorSx }} />}
                                                            label="CDN"
                                                            checked={item.account_type_currency == 1}
                                                            onChange={(e) => changeRegAccountCurrency(e, regIndex)}
                                                            name={`p_account_currency${item.value}`}
                                                            id={`p_account_cdn${item.value}`}
                                                            value={1}
                                                            disabled={item.account_checked == true ? false : true}
                                                        />
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <FormControlLabel
                                                            control={<Radio sx={{ radioColorSx }} />}
                                                            label="USD"
                                                            checked={item.account_type_currency == 2}
                                                            onChange={(e) => changeRegAccountCurrency(e, regIndex)}
                                                            id={`p_account_usd${item.value}`}
                                                            name={`p_account_currency${item.value}`}
                                                            value={2}
                                                            disabled={item.account_checked == true ? false : true}
                                                        />
                                                    </div>

                                                    {
                                                        (item?.account_count > 1) &&
                                                        <IconButton disabled={regIndex === 0} onClick={() => removePersonRegisterAccountType(regIndex, item.is_account_used, item?.is_account_used_message)} color="error">
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    }
                                                </div>
                                                {(item.account_count > 1) && <Divider className="divider mt-0" />}

                                                {item.account_checked && (
                                                    <>
                                                        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                                                            <Grid item xs={6}>
                                                                <Grid item xs={12} sm={12} md={12}>
                                                                    <label className='font15px margin-top10px'>What are the intended use of the accounts?</label>
                                                                </Grid>

                                                                <Grid item xs={12} sm={12} md={12} className='ml-10px mt-2'>
                                                                    <FormControl
                                                                        component="fieldset"
                                                                        variant="standard"
                                                                    >
                                                                        <FormGroup>
                                                                            {useOfAccountArray.map((option) => (
                                                                                <FormControlLabel
                                                                                    key={option.value}
                                                                                    className="custom-form-control-label"
                                                                                    control={
                                                                                        <Checkbox
                                                                                            sx={{
                                                                                                ...checkboxColorSx,
                                                                                                fontSize: "12px",
                                                                                                width: "max-content"
                                                                                            }}
                                                                                            checked={item.intended_use_of_account.includes(option.value)}
                                                                                            onChange={(e) => handlePerRegIntendedUseChange(e, regIndex, option.value)}
                                                                                        />
                                                                                    }
                                                                                    // label={option.label}
                                                                                    label={<Typography sx={{ fontSize: '14px', color: '#444' }}>{option.label}</Typography>}
                                                                                />
                                                                            ))}
                                                                        </FormGroup>
                                                                    </FormControl>
                                                                </Grid>
                                                            </Grid>

                                                            <Grid item xs={6} className='mt-4'>
                                                                {accountTypeDataArray.map(({ label, name, defaultValue, disabled }) => (
                                                                    <Grid container key={name} className="d-flex align-items-center mt-2" spacing={2}>
                                                                        <Grid item xs={12} sm={6} md={6} className='align-content-center pt-0'>
                                                                            <label htmlFor={`p-reg-${name}`} className="font14px">{label}</label>
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={6} md={6} className='align-content-center pt-0'>
                                                                            <FormControl component="fieldset">
                                                                                <RadioGroup
                                                                                    row
                                                                                    id={`p-reg-${name}`}
                                                                                    aria-labelledby={name}
                                                                                    name={name}
                                                                                    value={disabled ? 2 : item[name] ?? defaultValue ?? ''}
                                                                                    disabled={disabled}
                                                                                    onChange={(e) => handleChangeRegAccountData(e, regIndex)}
                                                                                >
                                                                                    {radioOptionArray.map((option) => (
                                                                                        <FormControlLabel
                                                                                            key={option.value}
                                                                                            value={option.value}
                                                                                            control={<Radio sx={{
                                                                                                ...radioColorSx,
                                                                                                fontSize: "12px"
                                                                                            }} />}
                                                                                            label={option.label}
                                                                                        />
                                                                                    ))}
                                                                                </RadioGroup>
                                                                            </FormControl>
                                                                        </Grid>

                                                                        {name === 'account_eft' && (
                                                                            <Grid item xs={12} className="align-self-center text-center font12px pt-0" sx={{ color: '#e05e5ecf' }}>
                                                                                Any account with a PAC, SWP, or Income Sweep that includes a bank account will also require EFT
                                                                            </Grid>
                                                                        )}
                                                                    </Grid>
                                                                ))}
                                                            </Grid>

                                                            {regIndex === personRegisterAccountDetails.findIndex(acc => acc.value === item.value) && (

                                                                <Grid item xs={12} sm={12} md={12} className='d-flex'>
                                                                    <Button
                                                                        sx={{ ml: "10px" }}
                                                                        onClick={() => addNewPersonRegAccount(item.label, item.value)}
                                                                        startIcon={<AddIcon />}
                                                                    >
                                                                        Add New {item.label}
                                                                    </Button>

                                                                </Grid>
                                                            )}
                                                        </Grid>
                                                    </>
                                                )}

                                            </>
                                        );
                                    })
                                }
                                control={control}
                            />
                        </FormControl>


                        <Divider className="divider mt-0" />
                    </Grid>

                    {/* --------------spousal account data -------------- */}

                    {
                        ((userData.p_marital_status == 2 || userData.p_marital_status == 3) && userData.s_investing_account == 1) &&
                        <Grid item xs={12} sm={12} md={12} className='mt-3'>
                            <Grid container className="d-flex align-items-center" spacing={2}>

                                <Grid item xs={12} sm={12} md={12} className='text-left'>
                                    <FormLabel className='font15px margin-right15px margin-top10px black-text'>Does your Spouse {userData.spousal_first_name || ''} also want to open an account?</FormLabel>

                                    <FormControl component="fieldset">
                                        <RadioGroup
                                            row
                                            aria-labelledby="is_spousal_account"
                                            name="is_spousal_account"
                                            value={formAccountData.is_spousal_account || ''}
                                            onChange={(e) => handleChange(e)}
                                        >
                                            {radioOptionArray.map((option) => {
                                                return (
                                                    <FormControlLabel
                                                        value={option.value}
                                                        control={<Radio sx={radioColorSx} />}
                                                        label={option.label}
                                                    />
                                                );
                                            })}
                                        </RadioGroup>
                                    </FormControl>
                                </Grid>
                            </Grid>



                            {(formAccountData.is_spousal_account == 1) &&
                                <>
                                    <Grid container className="d-flex align-items-center mt-2" spacing={2}>
                                        <Grid item xs={12} sm={12} md={12} className='d-flex'>
                                            <Grid item xs={5} sm={5} md={5}>
                                                <label className='font15px margin-top10px font-weight500px'>Non-Registered Account</label>
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={12}>
                                            <FormControl>
                                                <Controller
                                                    name="spousal_item_ids_non_reg"
                                                    // {...register('pNonRegisterSubAccountType')}
                                                    render={(props) =>
                                                        spousalNonRegisterAccountDetails?.map((item, index) => {
                                                            return (
                                                                <>
                                                                    {/* {(index > 0) && <Divider className="divider" />} */}
                                                                    <div className="d-flex">
                                                                        <input
                                                                            class="custom-checkbox"
                                                                            id={`s_account_non_reg_type${index}`}
                                                                            type="checkbox"
                                                                            onChange={(e) => handleCheckSpousalNonRegisterAccount(e, index)}
                                                                            checked={item.account_checked}
                                                                        />
                                                                        <label
                                                                            htmlFor={`s_account_non_reg_type${index}`}
                                                                            className='label-account-type'
                                                                        >
                                                                            {item.label}
                                                                        </label>

                                                                        {/* --------option ----------- */}
                                                                        <div className="form-check form-check-inline">
                                                                            <FormControlLabel
                                                                                control={<Radio sx={{ radioColorSx }} />}
                                                                                label="CDN"
                                                                                checked={item.account_type_currency == 1}
                                                                                onChange={(e) => changeSpousalNonRegAccountCurrency(e, index)}
                                                                                name={`s_account_non_reg_currency${item.value}`}
                                                                                id={`s_account_non_reg_cdn${item.value}`}
                                                                                value={1}
                                                                                disabled={item.account_checked == true ? false : true}
                                                                            />
                                                                        </div>
                                                                        <div className="form-check form-check-inline">
                                                                            <FormControlLabel
                                                                                control={<Radio sx={{ radioColorSx }} />}
                                                                                label="USD"
                                                                                checked={item.account_type_currency == 2}
                                                                                onChange={(e) => changeSpousalNonRegAccountCurrency(e, index)}
                                                                                id={`s_account_non_reg_usd${item.value}`}
                                                                                name={`s_account_non_reg_currency${item.value}`}
                                                                                value={2}
                                                                                disabled={item.account_checked == true ? false : true}
                                                                            />
                                                                        </div>

                                                                        {
                                                                            (item?.account_count > 1) &&
                                                                            <IconButton disabled={item?.account_count === 0} onClick={() => removeSpousalNonRegisterAccountType(index, item.is_account_used, item?.is_account_used_message)} color="error">
                                                                                <DeleteIcon />
                                                                            </IconButton>
                                                                        }
                                                                    </div>

                                                                    {(item.account_count > 1) && <Divider className="divider mt-0" />}

                                                                    {item.account_checked && (
                                                                        <>
                                                                            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                                                                                <Grid item xs={6}>
                                                                                    <Grid item xs={12} sm={12} md={12}>
                                                                                        <label className='font15px margin-top10px'>What are the intended use of the accounts?</label>
                                                                                    </Grid>

                                                                                    <Grid item xs={12} sm={12} md={12} className='ml-10px mt-2'>
                                                                                        <FormControl
                                                                                            component="fieldset"
                                                                                            variant="standard"
                                                                                        >
                                                                                            <FormGroup>
                                                                                                {useOfAccountArray.map((option) => (
                                                                                                    <FormControlLabel
                                                                                                        key={option.value}
                                                                                                        className="custom-form-control-label"
                                                                                                        control={
                                                                                                            <Checkbox
                                                                                                                sx={{
                                                                                                                    ...checkboxColorSx,
                                                                                                                    fontSize: "12px",
                                                                                                                    width: "max-content"
                                                                                                                }}
                                                                                                                checked={item.intended_use_of_account.includes(option.value)}
                                                                                                                onChange={(e) => handleSpousalIntendedUseChange(e, index, option.value)}
                                                                                                            />
                                                                                                        }
                                                                                                        // label={option.label}
                                                                                                        label={<Typography sx={{ fontSize: '14px', color: '#444' }}>{option.label}</Typography>}
                                                                                                    />
                                                                                                ))}
                                                                                            </FormGroup>
                                                                                        </FormControl>
                                                                                    </Grid>
                                                                                </Grid>

                                                                                <Grid item xs={6} className='mt-4'>
                                                                                    {accountTypeDataArray.map(({ label, name, defaultValue, disabled }) => (
                                                                                        <Grid container key={name} className="d-flex align-items-center mt-2" spacing={2}>
                                                                                            <Grid item xs={12} sm={6} md={6} className='align-content-center pt-0'>
                                                                                                <label htmlFor={`s-non-reg-${name}`} className="font14px">{label}</label>
                                                                                            </Grid>

                                                                                            <Grid item xs={12} sm={6} md={6} className='align-content-center pt-0'>
                                                                                                <FormControl component="fieldset">
                                                                                                    <RadioGroup
                                                                                                        row
                                                                                                        id={`s-non-reg-${name}`}
                                                                                                        aria-labelledby={name}
                                                                                                        name={name}
                                                                                                        value={disabled ? 2 : item[name] ?? defaultValue ?? ''}
                                                                                                        disabled={disabled}
                                                                                                        onChange={(e) => handleChangeSpousalNonRegAccountData(e, index)}
                                                                                                    >
                                                                                                        {radioOptionArray.map((option) => (
                                                                                                            <FormControlLabel
                                                                                                                key={option.value}
                                                                                                                value={option.value}
                                                                                                                control={
                                                                                                                    <Radio
                                                                                                                        sx={{
                                                                                                                            ...radioColorSx,
                                                                                                                            fontSize: "12px"
                                                                                                                        }}
                                                                                                                    />
                                                                                                                }

                                                                                                                label={option.label}
                                                                                                            />
                                                                                                        ))}
                                                                                                    </RadioGroup>
                                                                                                </FormControl>
                                                                                            </Grid>

                                                                                            {name === 'account_eft' && (
                                                                                                <Grid item xs={12} className="align-self-center text-center font12px pt-0" sx={{ color: '#e05e5ecf' }}>
                                                                                                    Any account with a PAC, SWP, or Income Sweep that includes a bank account will also require EFT
                                                                                                </Grid>
                                                                                            )}
                                                                                        </Grid>
                                                                                    ))}
                                                                                </Grid>

                                                                                {index === spousalNonRegisterAccountDetails.findIndex(acc => acc.value === item.value) && (
                                                                                    <Grid item xs={12} sm={12} md={12} className='d-flex'>
                                                                                        <Button
                                                                                            onClick={() => addSpousalNonRegAccountType(item.label, item.value)}
                                                                                            sx={{ ml: "10px" }}
                                                                                            startIcon={<AddIcon />}
                                                                                        >
                                                                                            Add New {item.label}
                                                                                        </Button>

                                                                                    </Grid>
                                                                                )}
                                                                            </Grid>
                                                                        </>
                                                                    )}
                                                                </>
                                                            );
                                                        })
                                                    }
                                                    control={control}
                                                />
                                            </FormControl>

                                            <Divider className="divider mt-0" />
                                        </Grid>


                                        {/* --------spousal register account ----------- */}

                                        <Grid item xs={12} sm={12} md={12} className='d-flex'>
                                            <Grid item xs={5} sm={5} md={5}>
                                                <label className='font15px margin-top10px font-weight500px'>Registered Account</label>
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={12}>
                                            <FormControl>
                                                <Controller
                                                    name="spousal_item_ids"
                                                    render={(props) =>
                                                        spousalRegisterAccountDetails?.map((item, regIndex) => {

                                                            return (
                                                                <>
                                                                    <div className="d-flex">
                                                                        <input
                                                                            class="custom-checkbox"
                                                                            id={`s_account_type${regIndex}`}
                                                                            type="checkbox"
                                                                            onChange={(e) => handleCheckSpousalRegisterAccount(e, regIndex)}
                                                                            checked={item.account_checked}
                                                                        />
                                                                        <label
                                                                            htmlFor={`s_account_type${regIndex}`}
                                                                            className='account-type-label'
                                                                        >
                                                                            {item.label}
                                                                        </label>

                                                                        <div
                                                                            className="form-check form-check-inline"
                                                                        >
                                                                            <FormControlLabel
                                                                                control={<Radio sx={{ radioColorSx }} />}
                                                                                label="CDN"
                                                                                checked={item.account_type_currency == 1}
                                                                                onChange={(e) => changeSpousalRegAccountCurrency(e, regIndex)}
                                                                                name={`s_account_currency${item.value}`}
                                                                                id={`s_account_cdn${item.value}`}
                                                                                value={1}
                                                                                disabled={item.account_checked == true ? false : true}
                                                                            />
                                                                        </div>
                                                                        <div className="form-check form-check-inline">
                                                                            <FormControlLabel
                                                                                control={<Radio sx={{ radioColorSx }} />}
                                                                                label="USD"
                                                                                checked={item.account_type_currency == 2}
                                                                                onChange={(e) => changeSpousalRegAccountCurrency(e, regIndex)}
                                                                                id={`s_account_usd${item.value}`}
                                                                                name={`s_account_currency${item.value}`}
                                                                                value={2}
                                                                                disabled={item.account_checked == true ? false : true}
                                                                            />
                                                                        </div>

                                                                        {
                                                                            (item?.account_count > 1) &&
                                                                            <IconButton disabled={regIndex === 0} onClick={() => removeSpousalRegisterAccountType(regIndex, item.is_account_used, item?.is_account_used_message)} color="error">
                                                                                <DeleteIcon />
                                                                            </IconButton>
                                                                        }
                                                                    </div>

                                                                    {(item.account_count > 1) && <Divider className="divider mt-0" />}

                                                                    {item.account_checked && (
                                                                        <>
                                                                            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                                                                                <Grid item xs={6}>
                                                                                    <Grid item xs={12} sm={12} md={12}>
                                                                                        <label className='font15px margin-top10px'>What are the intended use of the accounts?</label>
                                                                                    </Grid>

                                                                                    <Grid item xs={12} sm={12} md={12} className='ml-10px mt-2'>
                                                                                        <FormControl
                                                                                            // required
                                                                                            component="fieldset"
                                                                                            variant="standard"
                                                                                        >
                                                                                            <FormGroup>
                                                                                                {useOfAccountArray.map((option) => (
                                                                                                    <FormControlLabel
                                                                                                        key={option.value}
                                                                                                        className="custom-form-control-label"
                                                                                                        control={
                                                                                                            <Checkbox
                                                                                                                sx={{
                                                                                                                    ...checkboxColorSx,
                                                                                                                    fontSize: "12px",
                                                                                                                    width: "max-content"
                                                                                                                }}
                                                                                                                checked={item.intended_use_of_account.includes(option.value)}
                                                                                                                onChange={(e) => handleSpousalRegIntendedUseChange(e, regIndex, option.value)}
                                                                                                            />
                                                                                                        }
                                                                                                        // label={option.label}
                                                                                                        label={<Typography sx={{ fontSize: '14px', color: '#444' }}>{option.label}</Typography>}
                                                                                                    />
                                                                                                ))}
                                                                                            </FormGroup>
                                                                                        </FormControl>
                                                                                    </Grid>
                                                                                </Grid>

                                                                                <Grid item xs={6} className='mt-4'>
                                                                                    {accountTypeDataArray.map(({ label, name, defaultValue, disabled }) => (
                                                                                        <Grid container key={name} className="d-flex align-items-center mt-2" spacing={2}>
                                                                                            <Grid item xs={12} sm={6} md={6} className='align-content-center pt-0'>
                                                                                                <label htmlFor={`s-reg-${name}`} className="font14px">{label}</label>
                                                                                            </Grid>

                                                                                            <Grid item xs={12} sm={6} md={6} className='align-content-center pt-0'>
                                                                                                <FormControl component="fieldset">
                                                                                                    <RadioGroup
                                                                                                        row
                                                                                                        id={`s-reg-${name}`}
                                                                                                        aria-labelledby={name}
                                                                                                        name={name}
                                                                                                        value={disabled ? 2 : item[name] ?? defaultValue ?? ''}
                                                                                                        disabled={disabled}
                                                                                                        onChange={(e) => handleChangeSpousalRegAccountData(e, regIndex)}
                                                                                                    >
                                                                                                        {radioOptionArray.map((option) => (
                                                                                                            <FormControlLabel
                                                                                                                key={option.value}
                                                                                                                value={option.value}
                                                                                                                control={
                                                                                                                    <Radio
                                                                                                                        sx={{
                                                                                                                            ...radioColorSx,
                                                                                                                            fontSize: "12px"
                                                                                                                        }}
                                                                                                                    />
                                                                                                                }

                                                                                                                label={option.label}
                                                                                                            />
                                                                                                        ))}
                                                                                                    </RadioGroup>
                                                                                                </FormControl>
                                                                                            </Grid>

                                                                                            {name === 'account_eft' && (
                                                                                                <Grid item xs={12} className="align-self-center text-center font12px pt-0" sx={{ color: '#e05e5ecf' }}>
                                                                                                    Any account with a PAC, SWP, or Income Sweep that includes a bank account will also require EFT
                                                                                                </Grid>
                                                                                            )}
                                                                                        </Grid>
                                                                                    ))}
                                                                                </Grid>

                                                                                {regIndex === spousalRegisterAccountDetails.findIndex(acc => acc.value === item.value) && (
                                                                                    <Grid item xs={12} sm={12} md={12} className='d-flex'>
                                                                                        <Button
                                                                                            onClick={() => addNewSpousalRegAccount(item.label, item.value)}
                                                                                            sx={{ ml: "10px" }}
                                                                                            startIcon={<AddIcon />}
                                                                                        >
                                                                                            Add New {item.label}
                                                                                        </Button>

                                                                                    </Grid>
                                                                                )}
                                                                            </Grid>
                                                                        </>
                                                                    )}


                                                                </>
                                                            );
                                                        })

                                                    }
                                                    control={control}
                                                />

                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </>
                            }

                        </Grid>
                    }

                    <Divider className="divider mt-0" />

                    <Grid item xs={12} sm={12} md={12} className='d-flex'>
                        <Grid item xs={5} sm={5} md={5}>
                            <label className='font15px margin-top10px font-weight500px'>Please upload the statement for any accounts you wish to transfer to us.</label>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                        <Box
                            sx={{
                                // height: 400,
                                marginTop: 1,
                                width: 1,
                                '& .odd': {
                                    bgcolor: '#f5f5f5'
                                },
                                '& .even': {
                                    bgcolor: '#eee'
                                }
                            }}
                        >
                            <div className="file-card min-width-100px">
                                <div className="file-inputs">

                                    <input type="file" accept=".pdf,.doc,.docx" onChange={uploadHandler} className='file-upload' />
                                    <button className='upload-btn'>
                                        <i>
                                            <FontAwesomeIcon icon={faPlus} />
                                        </i>
                                        Upload
                                    </button>


                                </div>
                                <p className="main">Supported files</p>
                                <p className="info">Pdf, Png, Jpeg, jpg</p>

                                <ul className="file-list width100">
                                    {files.map(file => (
                                        <div className='file-li-class'>
                                            <li key={file.id} className="file-item">
                                                <FontAwesomeIcon icon={faFileAlt} className='margin-right10px' />
                                                <p className='mb-0'>{file.file_name}</p>
                                                <div className="actions">
                                                    <FontAwesomeIcon className='padding6px' icon={faDownload} onClick={() => downloadFile(file.file_name, file.id)} />
                                                    <FontAwesomeIcon className='padding6px' icon={faTrash} onClick={() => deleteFileHandler(file.file_name, file.id)} />
                                                </div>
                                            </li>
                                        </div>
                                    ))}
                                </ul>
                            </div>
                        </Box>
                    </Grid>


                </Grid> {/* END OF MAIN GRID */}



                <Grid item xs={12} sm={6} className='pt-3 text-center'>
                    <Button variant='outlined' className='m-3' onClick={handleRoleBack}>
                        Back
                    </Button>
                    <Button variant='contained' className='m-3 raintree-btn-green' type='submit'>
                        Next
                    </Button>
                </Grid>
            </form >
            {loader}
            <ToastContainer />
        </>
    )
}

export default AccountTypeInformation;